import * as React from 'react'
import Svg from '../Svg'
export const SvgClose = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        width="100pt"
        height="100pt"
        viewBox="0 0 100 100"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <path d="M50 0C22.656-.02.484 22.375.461 49.973.484 77.618 22.656 100.012 50 100c27.352.012 49.52-22.383 49.543-50.027C99.52 22.375 77.352-.019 50 0zm0 88.477c-21.035 0-38.094-17.227-38.078-38.504C11.902 28.743 28.961 11.512 50 11.52c21.047-.012 38.105 17.223 38.133 38.453C88.106 71.254 71.047 88.477 50 88.477z" />
        <path d="M72.027 37.465l-9.496-9.496L50 40.504 37.465 27.969l-9.496 9.496 12.539 12.543-12.54 12.527 9.497 9.496L50 59.496l12.53 12.535 9.497-9.496-12.531-12.527z" />
    </Svg>
)
SvgClose.isIcon = true
export default SvgClose
